import type { ErrorRegistryShape } from '../common/common.error';

/** 인증 · 세션 에러 코드 */
export const AUTH_ERROR = {
  /** 아이디 · 비밀번호 · 이메일 중 하나가 맞지 않는다. 어느 것이 틀렸는지는 알려 주지 않는다 */
  UNAUTHORIZED_LOGIN_FAILED: { status: 401, message: 'Invalid username, password or email' },
  UNAUTHORIZED_LOGIN_CODE_INVALID: { status: 401, message: 'Invalid verification code' },
  /** 인증번호가 만료됐거나 발급되지 않았다. 다시 발송해야 한다 */
  UNAUTHORIZED_LOGIN_CODE_EXPIRED: { status: 401, message: 'Verification code expired' },
  /** 리프레시 쿠키가 없거나, 만료 · 폐기됐거나, 재사용이 탐지됐다 */
  UNAUTHORIZED_SESSION_INVALID: { status: 401, message: 'Session is invalid or expired' },
  FORBIDDEN_ROLE_NOT_GRANTED: { status: 403, message: 'Role is not granted to this user' },
  /** 대리 로그인 세션은 읽기 전용이다 */
  FORBIDDEN_IMPERSONATION_READ_ONLY: { status: 403, message: 'Impersonation session is read-only' },
  /** 대리 중 재대리, 또는 대상이 될 수 없는 회원 */
  FORBIDDEN_IMPERSONATION_NOT_ALLOWED: { status: 403, message: 'Impersonation is not allowed' },
  /** 재설정 링크가 없거나 만료됐거나 이미 썼다 */
  UNAUTHORIZED_PASSWORD_RESET_INVALID: {
    status: 401,
    message: 'Password reset link is invalid or expired',
  },
  NOT_FOUND_MEMBER: { status: 404, message: 'Member not found' },
  /** 비밀번호 찾기: 그 이메일로 등록된 회원이 없다(DD-100 — 기존 서비스처럼 알려 준다). 비활성 계정은 이 코드가 아니라 204 */
  NOT_FOUND_PASSWORD_RESET_EMAIL: { status: 404, message: 'No member with this email' },
  /**
   * 구 서버 토큰을 이어받지 못했다(DD-88). 기한 지남 · 꺼짐 · 서명 · 로그인 기록 불일치 · 이미 씀 — 이유는 구분하지 않는다.
   * 웹은 구 토큰을 지우고 게스트로 시작한다
   */
  UNAUTHORIZED_LEGACY_TOKEN_REJECTED: {
    status: 401,
    message: 'Legacy session cannot be continued',
  },
} as const satisfies ErrorRegistryShape;
